<template>
  <div class="all_index">
    <div class="index_header_logo">
      <img src="../assets/logo_big.png" alt="" />
      <div class="index_header_text">智慧运维管理平台</div>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        position: absolute;
        right: 7%;
        top: 4%;
        z-index: 9;
      "
    >
      <div class="index_header_ai" @click="onToAI()">AI</div>
      <div class="index_header_login">
        <div class="home_top_left_img">
          <el-avatar
            shape="circle"
            :src="
              userInfo.avatar
                ? userInfo.avatar.includes('http')
                  ? userInfo.avatar
                  : IMAGE_HOST + userInfo.avatar
                : userInfo.avatar
            "
            @error="errorHandler"
          >
            <img :src="userInfo.sex == 1 ? useravatar_1 : useravatar_2" />
          </el-avatar>
        </div>
        <div class="home_top_left_name">
          <div class="home_top_left_name_top">
            {{ getTimeState() }}{{ userInfo.nickName }}
          </div>
          <div class="home_top_left_name_bottom">
            {{ getTimeStateStr() }}
          </div>
        </div>
        <div class="home_top_icon">
          <div style="margin: 0 8px" @click="GouserInfo">
            <Icon type="ios-contact-outline" size="32" />
          </div>
          <div @click="onOutLogin"><Icon type="ios-log-out" size="32" /></div>
        </div>
      </div>
    </div>
    <!-- <div class="index_header">
      
    </div> -->
    <div class="index_main">
      <img src="../assets/index_img/bg_top.png" alt="" />
      <div class="index_main_btn index_main_hy" @click="onTo(3)">会议预定</div>
      <div class="index_main_btn index_main_zh" @click="onTo(1)">智慧运维</div>
      <div class="index_main_btn index_main_zyxz" @click="onTo(12)">
        资源下载
      </div>
      <div class="index_main_btn index_main_wz" @click="onTo(2)">物资商城</div>
      <div class="index_main_btn index_main_zs" @click="onTo(10)">设备台账</div>
      <div class="index_main_btn index_main_ks" @click="onTo(6)">
        基础信息维护
      </div>
      <div class="index_main_btn index_main_bbzx" @click="onTo(13)">
        报表中心
      </div>
      <div class="index_main_xm" @click="onTo(4)">
        <div class="index_main_xm_text">项目管理</div>
      </div>
    </div>
    <div class="index_footer">
      <div class="index_footer_left">
        <!-- <a
          href="https://misdemo-design.seeyoncloud.com/seeyon/main.do"
          target="_blank"
        >
          <div class="footer_left_item">
            <img src="../assets/index_img/yyzt_icon.png" alt="" />
            全面预算运营中台
          </div>
        </a> -->
        <!-- <div class="footer_left_item" @click="onTo(5)">
          <img src="../assets/index_img/shfw_icon.png" alt="" />
          智慧生活服务平台
        </div>
        <div class="footer_left_item" @click="onTo(11)">
          <img src="../assets/index_img/zhyl_icon.png" alt="" />
          智慧医疗服务平台
        </div> -->
      </div>
      <div class="index_footer_right">
        <!-- <div class="footer_right_item">
                    <div class="right_item_img"><img src="../assets/index_img/jcsz.png" alt=""></div>
                    基础设置
                </div>-->
        <div class="footer_right_item" @click="onTo(9)">
          <div class="right_item_img">
            <img src="../assets/index_img/xtsz.png" alt="" />
          </div>
          系统设置
        </div>
      </div>
    </div>
    <Modal
      v-model="passwordModal"
      title="当前账号为首次登录，请修改密码！"
      :show-cancel="false"
      :mask-closable="false"
      :closable="false"
    >
      <div>
        <!-- <div class="password_item">
          <div class="password_item_left">旧密码：</div> -->
        <!-- <div class="inputBox password_item_right">
            <VirtualPwdInputEdit
              placeholderValue="请输入旧密码"
              v-model="oldPassword"
            />
          </div> -->
        <!-- <Input
            v-model="oldPassword"
            type="password"
            password
            placeholder="请输入旧密码"
            autocomplete="new-password"
            :name="'pwd_' + Date.now()"
            style="width: 200px"
          /> -->
        <!-- </div> -->
        <div class="password_item">
          <div class="password_item_left">新密码：</div>
          <div class="inputBox password_item_right">
            <VirtualPwdInputEdit
              placeholderValue="请输入新密码"
              v-model="newPassword"
            />
          </div>
          <!-- <Input
            v-model="newPassword"
            type="password"
            password
            placeholder="请输入新密码"
            style="width: 200px"
          /> -->
        </div>
        <div class="password_item">
          <div class="password_item_left">确认密码：</div>
          <div class="inputBox password_item_right">
            <VirtualPwdInputEdit
              placeholderValue="请输入新密码"
              v-model="enterPassword"
            />
          </div>
          <!-- <Input
            v-model="enterPassword"
            type="password"
            password
            placeholder="请输入新密码"
            style="width: 200px"
          /> -->
        </div>
      </div>
      <template slot="footer">
        <div>
          <Button type="primary" @click="onEntersubmit">确定</Button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Calling from "./callcenter/calling.vue";
import { IMAGE_HOST } from "../../config";
import useravatar_1 from "../assets/img/useravatar_1.png";
import useravatar_2 from "../assets/img/useravatar_2.png";
import VirtualPwdInput from "./VirtualPwdInput.vue";
import VirtualPwdInputEdit from "./VirtualPwdInputEdit.vue";
export default {
  components: { VirtualPwdInput, VirtualPwdInputEdit },
  data() {
    return {
      deskName: "",
      address: "",
      isCalling: false,
      userInfo: {},
      IMAGE_HOST: IMAGE_HOST,
      useravatar_1: useravatar_1,
      useravatar_2: useravatar_2,
      authList: [],
      visible: false,
      passwordModal: false,
      // oldPassword: "",
      newPassword: "",
      enterPassword: "",
    };
  },

  created() {
    $utils.data.set("auth", "isAuthRecord", "");
    this.getLogin();
    this.getInfoFun();
    this.loadUserInfo();
    // this.getAuthList()
    // 显示打开的页面的列表
    if (
      window.localStorage.getItem("mainType") != "2" &&
      window.localStorage.getItem("mainType") != "3" &&
      !$utils.data.get("UserInfo", "Calling")
    ) {
      $utils.data.set("UserInfo", "Calling", true);
      let _that = this;
      this.$bus.$on("zuoxi", async function () {
        if (
          _that.isCalling ||
          $utils.data.get("auth", "auths") === [] ||
          !$utils.data.get("auth", "auths")
        ) {
          return;
        }
        try {
          _that.isCalling = true;
          await _that.getUserCall();
        } finally {
          _that.isCalling = false;
        }
      });
    }
  },
  mounted() {},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      if (from.name == "login") {
        window.location.reload(true);
      }
    });
  },
  methods: {
    onEntersubmit() {
      let userId = $utils.data.get("auth", "uid");
      // if (!this.oldPassword) {
      //   $utils.toast.success("请输入旧密码！");
      //   return;
      // }
      if (!this.newPassword) {
        $utils.toast.success("请输入新密码！");
        return;
      }
      if (!this.enterPassword) {
        $utils.toast.success("请再次输入新密码！");
        return;
      }
      let passwordReg = /^(?=.*[a-zA-Z])(?=.*\d).{6,32}$/;
      let passwordChk = passwordReg.test(this.newPassword);
      if (!passwordChk) {
        return $utils.toast.error(
          "密码至少包含字母，数字，且不少于6位，不大于32位！"
        );
      }
      if (this.newPassword != this.enterPassword) {
        $utils.toast.success("确认密码错误，请重新输入！");
        return;
      }
      let q = {
        // oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        confirmPassword: this.enterPassword,
        userId: userId,
      };

      $utils.api
        .load("/admin/system/user/firstUpdatePwd", q, "post")
        .then((res) => {
          if (res.code == 200) {
            // this.form.password = "";
            $utils.toast.success("修改成功");
            this.passwordModal = false;
          } else {
            $utils.toast.error(res.msg);
          }
        })
        .catch((err) => {
          $utils.toast.error(err.message || "修改失败，请重试");
        });
    },
    GouserInfo() {
      $utils.data.set("auth", "isAuths", 14);
      this.$store.commit("updateMenulist");
      $utils.url.push({ name: "userInfo_Index" });
    },
    onToAI() {
      $utils.url.push({ name: "e_ai" });
    },
    onOutLogin() {
      // 退出登录
      $utils.api.load("authLogout").then((res) => {
        $utils.data.set("auth", "auths", []);
        window.localStorage.setItem("token", "");
        $utils.data.clear("auth");
        $utils.data.clear("storage");
        this.$store.commit("logout", this);
        this.$router.push({
          name: "login",
        });
      });
    },
    async onTo(key) {
      let parentId = "";
      let isKey = key;

      switch (key) {
        case 3:
          parentId = await this.isMenuId("会议预定");
          break;
        case 1:
          parentId = await this.isMenuId("智慧运维");
          break;
        case 2:
          parentId = await this.isMenuId("物资商城");
          break;
        case 5:
          parentId = await this.isMenuId("智慧生活服务平台");
          break;
        case 6:
          parentId = await this.isMenuId("基础信息维护");
          break;
        case 4:
          parentId = await this.isMenuId("项目管理");
          break;
        case 7:
          // auth = "system/scheduleMeeting/index"
          break;
        case 8:
          // auth = "system/scheduleMeeting/index"
          break;
        case 9:
          parentId = await this.isMenuId("系统设置");
          break;
        case 10:
          parentId = await this.isMenuId("设备台账");
          break;
        case 11:
          parentId = await this.isMenuId("智慧医疗服务平台");
          break;
        case 12:
          parentId = await this.isMenuId("资源下载");
          break;
        case 13:
          parentId = await this.isMenuId("报表中心");
        default:
          break;
      }
      if (parentId) {
        this.getUserAuthList(parentId, isKey);
      } else {
        this.$message({
          showClose: true,
          center: true,
          dangerouslyUseHTMLString: true,
          message: "<h3>暂无权限</h3>",
          type: "error",
          offset: window.innerHeight / 2 - 50,
        });
      }
    },
    async isMenuId(key) {
      return new Promise((resolve, reject) => {
        let q = {};
        $utils.api.load("/admin/system/menu/m/list", q, "get").then((res) => {
          console.log(res);
          if (res.code == 200) {
            let a = "";
            let authLists = res.rows;
            authLists.forEach((item) => {
              console.log(item.sysMenuMouldId, key);
              if (item.menuName == key) {
                a = item.menuId;
              }
            });
            resolve(a);
          }
        });
      });
    },
    async getAuthList() {
      let q = {};
      let res = await $utils.api.load("/admin/system/menu/m/list", q, "get");
      console.log(res);
      if (res.code == 200) {
        this.authList = res.rows;
      }
    },
    async getUserAuthList(parentId, key) {
      let q = {};
      let res = await $utils.api.load(
        `/admin/loginCheckMenu/${parentId}`,
        q,
        "get"
      );
      console.log(res);
      if (res.code == 200) {
        // this.authList = res.rows
        let list = res.data[0];
        if (list.children) {
          $utils.data.set("auth", "isAuths", key);
          this.$store.commit("updateMenulist");
          switch (key) {
            case 3:
              $utils.url.push({ path: "/scheduleMeeting" });
              break;
            case 1:
              $utils.url.push({ name: "simple" });
              break;
            case 2:
              $utils.url.push({ name: "consumables_list" });
              break;
            case 5:
              $utils.url.push({ name: "facilityTracking1" });
              break;
            case 6:
              $utils.url.push({ name: "contacts_list" });
              break;
            case 4:
              $utils.url.push({ name: "project_list" });
              break;
            case 7:
              // auth = "system/scheduleMeeting/index"
              break;
            case 8:
              // auth = "system/scheduleMeeting/index"
              break;
            case 9:
              $utils.url.push({ name: "configure_list" });
              break;
            case 10:
              $utils.url.push({ name: "deviceretrieval_list" });
              break;
            case 11:
              $utils.url.push({ name: "PatientWork_await" });
              break;
            case 12:
              $utils.url.push({ name: "fileDownload" });
              break;
            case 13:
              $utils.url.push({ name: "service_reporting" });
              break;
            default:
              break;
          }
        }
      }
    },
    onToindex() {
      $utils.url.push({ path: "/index" });
    },
    async loadUserInfo() {
      let userId = $utils.data.get("auth", "uid");
      let res = await $utils.api.load(`/admin/system/user/get/${userId}`);
      console.log(res);
      if (res.code == 200) {
        this.userInfo = res.data;
      }
    },
    errorHandler() {
      return true;
    },
    getTimeState() {
      // var user = '神秘剑客漫步云端'
      // 获取当前时间
      let timeNow = new Date();
      // 获取当前小时
      let hours = timeNow.getHours();
      // 设置默认文字
      let state = ``;
      // 判断当前时间段
      if (hours >= 0 && hours <= 11) {
        state = `上午好，`;
      } else if (hours > 11 && hours <= 13) {
        state = `中午好，`;
      } else if (hours > 13 && hours <= 18) {
        state = `下午好，`;
      } else if (hours > 18 && hours <= 24) {
        state = `晚上好，`;
      }
      return state;
    },
    getTimeStateStr() {
      // var user = '神秘剑客漫步云端'
      // 获取当前时间
      let timeNow = new Date();
      // 获取当前小时
      let hours = timeNow.getHours();
      // 设置默认文字
      let state = ``;
      // 判断当前时间段
      if (hours >= 0 && hours <= 11) {
        state = `今天又是元气满满的一天！`;
      } else if (hours > 11 && hours <= 13) {
        state = `记得吃午饭哦~`;
      } else if (hours > 13 && hours <= 18) {
        state = `合理工作，注意休息哦~`;
      } else if (hours > 18 && hours <= 24) {
        state = `早点休息哦~`;
      }
      return state;
    },

    async getDeskInfo(id) {
      if (id == undefined) {
        return;
      } else {
        let res = await $utils.api.load(`/admin/system/desk/${id}`);
        if (res.code === 200) {
          if (res.data) {
            this.deskName = res.data.deskName;
            this.address = res.data.address;
          }
        }
      }
    },
    getInfoFun() {
      let q = {};
      $utils.api.load("admin/getInfo", q, "get").then((res) => {
        console.log(res);
        if (res.code == 200) {
          if (res.isFirstLogin) {
            this.passwordModal = true;
          }
        }
      });
    },
    getLogin() {
      //检测登录状态
      let MaintainerToken = global.$utils.data.get("", "token");

      if (!MaintainerToken) {
        if (window.localStorage.getItem("token") == '{"data":""}') {
          // $utils.url.push({ name: 'login' })
          return false;
        }
      }
      // 检测登录状态
      $utils.api
        .load("authCheck", {}, "post", {
          toast: false,
          toasterror: false,
          loading: false,
          loadingtext: "Loading",
          login: false,
        })
        .then((res) => {
          if (res.code != 200) {
            if (
              window.localStorage.getItem("pcFun") == 2 ||
              window.localStorage.getItem("pcFun") == 5
            ) {
              return;
            } else {
              // 登录
              $utils.url.push({ name: "login" });
              return false;
            }
          }
          if (res.user && res.auths) {
            const last_login_time = $utils.time.format(
              res.user.loginDate || ""
            );
            $utils.data.set("auth", "last_login_time", last_login_time);
            $utils.data.set("auth", "auths", []);
            $utils.data.set("auth", "username", res.user.nickName);
            $utils.data.set("auth", "userName", res.user.userName);
            $utils.data.set("auth", "suid", res.user.userId);
            $utils.data.set("auth", "uid", res.user.userId);
            $utils.data.set("auth", "uname", res.user.nickName);
            $utils.data.set("auth", "isAdmin", res.user.isAdmin);
            $utils.data.set(
              "auth",
              "avatar",
              $utils.image.load(res.user.avatar) ||
                require("@/assets/img/useravatar.jpg")
            );
            $utils.data.set("auth", "auths", res.auths);
            $utils.data.set("auth", "makeMain", res.makeMain);
            $utils.data.set("auth", "deskId", res.user.deskId);
            global.$utils.data.set("auth", "makeMain", res.makeMain);
            // const last_login_time = $utils.time.format(res.data.last_login_time || '')
            // $utils.data.set('auth', 'last_login_time', last_login_time)
            // $utils.data.set('auth', 'auths', [])
            // $utils.data.set('auth', 'username', res.data.username)
            // $utils.data.set('auth', 'suid', res.data.suid)
            // $utils.data.set('auth', 'uid', res.data.uid)
            // $utils.data.set('auth', 'uname', res.data.uname)
            // $utils.data.set('auth', 'avatar', $utils.image.load(res.data.head) || require('@/assets/img/useravatar.jpg'))
            // $utils.data.set('auth', 'auths', res.data.auths)
            // $utils.data.set('auth', 'is_system', res.data.is_admin)
            // $utils.data.set('auth', 'is_admin', res.data.is_admin)
            // $utils.data.set('auth', 'is_all_order', res.data.is_all_order)
            // $utils.data.set('auth', 'shop_id', res.data.shop_id)
            // $utils.data.set('auth', 'shop_name', res.data.shop_name)
            // 强制刷新页面 否则左侧路由无法更新
            this.$store.commit("updateMenulist");
            if (res.user.deskId) {
              this.getDeskInfo(res.user.deskId);
            }
          } else {
            $utils.toast.error(res.message);
          }
        });
    },
    async getCustomerInfo() {
      // 加载详情数据
      let res = await $utils.api.load(
        `/admin/system/customer/getCustomerInfo`,
        {},
        "GET"
      );
      if (res && res.data) {
        window.localStorage.setItem("customerId", res.data.id);
        window.localStorage.setItem("customerName", res.data.customerName);
        this.customerName = res.data.customerName;
        if (res.data.id === 149) {
          this.schoolId = true;
          this.logo = config.logoSchool;
          this.minlogo = config.minlogoSchool;
        }
      }
    },
    async getUserCall() {
      // 加载详情数据
      let res = await $utils.api.load(
        `/admin/system/user/getUserInfo`,
        {},
        "GET"
      );
      if (res && res.data) {
        if (res.data.channelIds !== "")
          await this.initChart(res.data.channelIds);
      }
    },
    async initChart(channelId) {
      let res2 = await $utils.api.load(`/admin/system/record/getCalling`, {});
      if (res2 && res2.code === 200 && res2.data) {
        let callVo = res2.data;
        this.$Modal.success({
          closable: true,
          width: "1200px",
          // okButtonProps:{ style: { display: 'none' } },
          // footerHide: true,
          okText: "取消",
          showOk: false,
          render: (h) => {
            return (
              <Calling
                style={{ margin: "0", color: "#19be6b" }}
                deskId={callVo.deskId}
                phone={callVo.callno}
                callId={callVo.id}
              ></Calling>
            );
          },
        });
      }
      // });
      // }
    },
  },
};
</script>

<style scoped lang="less">
.all_index {
  width: 100vw;
  height: 100vh;
  background: url("../assets/index_img/bg.png") no-repeat;
  background-size: 100% 100%;
  position: relative;

  // .index_header {
  //   width: 100%;
  //   display: flex;
  //   padding: 0 7%;
  //   justify-content: space-between;
  //   align-items: center;
  //   position: absolute;
  //   top: 4%;
  //   left: 0;
  //   z-index: 5;

  .index_header_logo {
    font-size: 0;
    position: absolute;
    left: 7%;
    top: 4%;
    display: flex;
    align-items: center;
    // flex-direction: column;

    img {
      height: calc((100vw / 100 - 100vw / 1000) * 3);
      margin-right: 10px;
    }

    .index_header_text {
      font-size: calc((100vw / 100 - 100vw / 1000) * 1.2);
      color: #000;
      text-align: center;
      font-weight: 800;
    }
  }

  .index_header_ai {
    background: #409eff;
    color: #fff;
    border-radius: 10px;
    font-weight: 700;
    padding: calc((100vw / 100 - 100vw / 1000) / 1.2)
      calc((100vw / 100 - 100vw / 1000) * 1.2);
    font-size: calc(100vw / 100 - 100vw / 1000);
    margin-right: 10px;
  }

  .index_header_login {
    // background: url("../assets/index_img/login_bg.png") no-repeat;
    // background-size: 100% 100%;
    background: rgba(234, 241, 253, 0.85);
    border: 2px solid rgba(255, 255, 255, 0.8);
    border-radius: 20px;
    display: flex;
    align-items: center;
    padding: calc((100vw / 100 - 100vw / 1000) / 1.2)
      calc((100vw / 100 - 100vw / 1000) * 1.2);

    .home_top_left_img {
      display: flex;
      align-items: center;
      margin-right: 10px;

      /deep/.el-avatar {
        width: calc((100vw / 100 - 100vw / 1000) * 3);
        height: calc((100vw / 100 - 100vw / 1000) * 3);
      }
    }

    .home_top_left_name {
      font-size: calc(100vw / 100 - 100vw / 1000 * 3);
      .home_top_left_name_top {
        display: flex;
        align-items: center;
      }
    }
    .home_top_icon {
      display: flex;
      align-items: center;
    }
  }

  // }

  .index_main {
    width: 62vw;
    position: absolute;
    top: 46%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 5;

    img {
      width: 100%;
    }

    .index_main_btn {
      z-index: 8;
      position: absolute;
      background: url("../assets/index_img/btn_bg.png") no-repeat;
      background-size: 100% 100%;
      width: 11%;
      height: 6%;
      display: flex;
      justify-content: center;
      // align-items: center;
      line-height: calc((100vw / 100 - 100vw / 1000) * 2.5);
      color: #fff;
      font-weight: 800;
      font-size: calc(100vw / 100 - 100vw / 1000);
      transition: transform 0.3s ease;
      cursor: pointer;
    }

    .index_main_btn:hover {
      transform: scale(1.1);
    }

    .index_main_xm {
      position: absolute;
      top: 32.2%;
      left: 43.6%;
      font-weight: 800;
      color: #fff;
      font-size: calc(100vw / 100 - 100vw / 1000);
      // transform: rotateX(25deg) rotateY(10deg) rotateZ(323deg);
      transform-style: preserve-3d;
      transition: transform 0.3s ease;
      cursor: pointer;
      width: 15%;
      height: 10%;
      display: flex;
      justify-content: center;
      align-items: center;

      .index_main_xm_text {
        transform-origin: 0;
        // transform: rotate3d(1, 1, 1, -74deg);
        // transform: rotateX(-10deg) rotateZ(-31deg) rotateY(8deg) skewX(22deg) skewY(0deg);
        transform: rotateX(0deg) rotateZ(-26deg) rotateY(8deg) skewX(34deg)
          skewY(-5deg);
      }
    }

    .index_main_xm:hover {
      transform: scale(1.1);
    }

    .index_main_hy {
      top: 52%;
      left: 0;
    }

    .index_main_zh {
      top: 8%;
      left: 20%;
    }

    .index_main_zyxz {
      top: 8%;
      left: 32%;
      background: none;
      justify-content: left;
      color: #5f6779;
    }

    .index_main_ks {
      bottom: 16%;
      left: 58%;
    }

    .index_main_bbzx {
      bottom: 16%;
      left: 70%;
      background: none;
      justify-content: left;
      color: #5f6779;
    }

    .index_main_zs {
      top: 52%;
      right: 0;
    }

    .index_main_wz {
      top: 24%;
      right: 6%;
    }
  }

  .index_footer {
    display: flex;
    width: 100%;
    justify-content: space-between;
    position: absolute;
    bottom: 6%;
    left: 0;
    padding-left: 7%;
    padding-right: 7%;

    .index_footer_left {
      display: flex;
      align-items: center;

      .footer_left_item {
        color: #5f6779;
        display: flex;
        align-items: center;
        margin-right: 20px;
        background: #fff;
        padding: calc(100vw / 100 - 100vw / 1000)
          calc((100vw / 100 - 100vw / 1000) * 2);
        border-radius: 10px;
        font-size: calc(100vw / 100 - 100vw / 1000);

        img {
          width: calc((100vw / 100 - 100vw / 1000) * 2.5);
          margin-right: 10px;
        }
      }
    }

    .index_footer_right {
      display: flex;
      align-items: center;
      justify-content: right;
      flex: 1;

      .footer_right_item {
        display: flex;
        height: 100%;
        flex-direction: column;
        align-items: center;
        background: url("../assets/index_img/szbg.png") no-repeat;
        background-size: 100% 100%;
        aspect-ratio: 1 / 1;
        justify-content: center;
        margin-left: 20px;
        font-size: calc(100vw / 100 - 100vw / 1000 * 2);
        padding: 10px;

        .right_item_img {
          height: calc((100vw / 100 - 100vw / 1000) * 2);
          aspect-ratio: 41 / 44;
          font-size: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 5px;
        }

        img {
          height: calc((100vw / 100 - 100vw / 1000) * 2);
        }
      }
    }
  }
}
.password_item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .password_item_left {
    width: 80px;
  }
  .password_item_right {
    width: 70%;
  }
}
div.inputBox {
  height: 36px;
  position: relative;
}

div.inputBox:focus {
  border: 1px solid #000;
}

div.inputBox.hasIcon {
  background-size: 12px auto;
  background-position: left 10px center;
  background-repeat: no-repeat;
}

div.inputBox.hasIcon input {
  text-indent: 38px;
}

div.inputBox .backIcon {
  position: absolute;
  font-size: 20px;
  width: 22px;
  left: 10px;
  top: 6px;
  color: #888;
}

div.inputBox input {
  font-size: 14px;
  border: none;
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  width: 100%;
  line-height: 34px;
  height: 36px;
  display: block;
  text-indent: 10px;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 2px;
  border: 1px solid #eee;
  background: transparent;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

div.inputBox input:focus {
  border: 1px solid #2a75ed;
}

div.inputBox.alert input {
  border-color: #fb6161;
}

div.inputBox.alert + .inputAlert {
  display: block;
  color: #fb6161;
  font-size: 12px;
  margin: 0;
  line-height: 12px;
  margin-top: -22px;
  margin-bottom: 10px;
  position: absolute;
}

div.inputBox.alert + .inputAlert.hasTitle {
  margin-left: 66px;
}

div.inputBox + .inputAlert {
  display: none;
}

a {
  text-decoration: none;
  color: #2a75ed;
  font-size: 12px;
}

button.btn {
  width: 100%;
  height: 36px;
  border-radius: 2px;
  font-size: 14px;
  line-height: 36px;
  border: none;
  cursor: pointer;
  margin-top: 10px;
}

button.btn.blue {
  color: #fff;
  background-color: #2a75ed;
}

button.btn.grey {
  background-color: #f5f7fa;
  border: 1px solid #e5e7ea;
  color: #666;
}

button.btn.opacity {
  opacity: 0.3;
  outline: none;
}
</style>
